const UNSUBSCRIBE_PATH_PREFIX = '/unsubscribe/';
const TOKEN_PARAM = 'token';

const storageKey = () => `email-subscription-token:${window.location.pathname}`;

const recall = () => {
    try {
        return window.sessionStorage.getItem(storageKey());
    } catch {
        return null;
    }
};

const captureFromUrl = () => {
    if (!window.location.pathname.startsWith(UNSUBSCRIBE_PATH_PREFIX)) {
        return null;
    }

    const url = new URL(window.location.href);
    const token = url.searchParams.get(TOKEN_PARAM);

    if (token === null) {
        return recall();
    }

    url.searchParams.delete(TOKEN_PARAM);
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);

    try {
        window.sessionStorage.setItem(storageKey(), token);
    } catch {
        return token;
    }

    return token;
};

const token = captureFromUrl();

export const emailSubscriptionToken = () => token;
